// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"ba81bd60","339":"df6118c7","442":"828ba0f4","488":"11ca1818","919":"700a6e16"}[chunkId] + ".chunk.js";
};